import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Icon, Title } from '@fnacdarty/back-office-ui';
import PropTypes from 'prop-types';

import { StyledLoadingContainer, StyledModal } from './index.styled';
import './blurModal.css';

const Modal = ({
	onClickCallback,
	title,
	cancelAction,
	confirmAction,
	returnValues,
	children,
	loading = false,
	...props
}) => {
	useEffect(() => {
		document.body.style.overflow = 'hidden';
		document.getElementById('root').classList.add('blurModal');
		// document.getElementById('camera').classList.add('no-event');
		return () => {
			document.body.style.overflow = 'auto';
			document.getElementById('root').classList.remove('blurModal');
		};
	}, []);

	return ReactDOM.createPortal(
		<StyledModal {...props}>
			{loading && (
				<StyledLoadingContainer>
					<Icon name="loader" width={30} />
				</StyledLoadingContainer>
			)}
			<div className="modal__header">
				<Title level={3} className="modal__header__title">
					{title}
				</Title>
			</div>
			<div className="modal__content">{children}</div>
			<div className="modal__action">
				{cancelAction ? (
					<span
						className="modal__cancel"
						onClick={() => {
							onClickCallback(false, returnValues);
						}}
					>
						{cancelAction}
					</span>
				) : (
					<span />
				)}
				<span
					className="modal__valid"
					onClick={() => {
						onClickCallback(true);
					}}
				>
					{confirmAction}
				</span>
			</div>
		</StyledModal>,
		document.getElementById('modal'),
	);
};

Modal.propTypes = {
	onClickCallback: PropTypes.func.isRequired,
	children: PropTypes.node.isRequired,
	title: PropTypes.string.isRequired,
	cancelAction: PropTypes.string,
	confirmAction: PropTypes.string,
	// eslint-disable-next-line react/forbid-prop-types
	returnValues: PropTypes.object,
};

Modal.defaultProps = {
	cancelAction: 'Non',
	confirmAction: 'Oui',
};

export default Modal;
